import { render, staticRenderFns } from "./audio-collection.vue?vue&type=template&id=4978d966&scoped=true"
import script from "./audio-collection.vue?vue&type=script&lang=js"
export * from "./audio-collection.vue?vue&type=script&lang=js"
import style0 from "./audio-collection.vue?vue&type=style&index=0&id=4978d966&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4978d966",
  null
  
)

export default component.exports